import { Module } from "vuex";
import { RootState } from "@/store/type";
import { UiState } from "@/store/ui/type";
import { getters } from "@/store/ui/getters";
import { actions } from "@/store/ui/actions";
import { mutations } from "@/store/ui/mutations";

const state: UiState = {
  isLoginModalOpen: { open: false, isReloaded: false },
  isCartSidebarOpen: false,
  isProductsActionModal: { open: false, type: null, product: null },
  isNoStockActionModal: { open: false, products: [] },

  isWelcomeModal: { open: false, customer: null },
  isColissimoModalOpen: { open: false, address: null, selectedRelais: null, shipmentWeight: 0 },
  isResetModal: { open: false, email: null, status: null },
  isMenuModalOpen: false,
  isAddressModalOpen: false,
  isAddressListModalOpen: false,
  notifications: [],
  isSearchOpen: false,
  indexGallery: null,
  productGallery: [],
  currentLocal: "",
};

export const ui: Module<UiState, RootState> = {
  state,
  getters,
  mutations,
  actions,
};




